/* eslint-disable no-return-await */
import { requestApi } from './Api';

export const getType = async (navigate, params) =>
  await requestApi({ navigate, url: '/api/endpoint/type', params });

export const getAction = async (navigate, params) =>
  await requestApi({ navigate, url: '/api/endpoint/action', params });
